// Product card quick view focus
document.addEventListener('keydown', function (event) {
  const quickView = event.target.closest('.product-image__wrapper .js-quick-shop-link');
  if (!quickView) return;
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    quickView.click();
  }
});

// Product page color swatches
document.addEventListener('change', function(event) {
  const radio = event.target;
  if (!radio.matches('[data-variant-option-value]')) return;

  setTimeout(() => {
    radio.focus();
  }, 0);
});



// Checkout button script on cart page
document.addEventListener('DOMContentLoaded', function () {

  const checkoutBtn = document.querySelector('.cart__checkout .add_to_cart');

  if (!checkoutBtn) return;

  checkoutBtn.addEventListener('keydown', function (e) {

    if (e.key === 'Enter') {
      e.preventDefault();

      // Trigger native checkout button click
      this.click();
    }
  });
});

// Product quantity(+,-) keyboard accessiblity issue
document.addEventListener('keydown', function (event) {

  const button = event.target.closest(
    '.quantity-minus, .quantity-plus'
  );

  if (!button || button.tagName === 'BUTTON') return;

  if (event.key === 'Enter' || event.key === ' ') {

    event.preventDefault();

    const quantityBox = button.closest(
      '.product-quantity-box'
    );

    if (!quantityBox) return;

    // Save focused button type
    const isPlus = button.classList.contains('quantity-plus');

    // Save line item identifier
    const lineItemKey = quantityBox.dataset.lineItemKey;

    // Trigger existing theme logic
    button.click();

    // Wait for AJAX/cart rerender
    setTimeout(() => {

      const updatedQuantityBox = document.querySelector(
        '.product-quantity-box[data-line-item-key="' +
        lineItemKey +
        '"]'
      );

      if (!updatedQuantityBox) return;

      const focusButton = updatedQuantityBox.querySelector(
        isPlus
          ? '.quantity-plus'
          : '.quantity-minus'
      );

      if (focusButton) {
        focusButton.focus();
      }

    }, 500);
  }
});

document.addEventListener('DOMContentLoaded', function () {

  const quantityButtons = document.querySelectorAll(
    '.cart__quantity .quantity-minus, .cart__quantity .quantity-plus'
  );

  quantityButtons.forEach(function (button) {
    if (button.tagName === 'BUTTON') return;

    button.addEventListener('keydown', function (event) {

      if (event.key === 'Enter' || event.key === ' ') {

        // Prevent cart form submission
        event.preventDefault();
        event.stopPropagation();

        // Trigger existing click logic
        this.click();
      }
    });
  });

});

/*document.addEventListener('keydown', function (event) {
  const button = event.target.closest(
    '.quantity-minus, .quantity-plus'
  );
  if (!button) return;

  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    const wrapper = button.closest('.quantity-wrapper');
    if (!wrapper) return;
    const input = wrapper.querySelector('.quantity-input');
    if (!input) return;
    let value = parseInt(input.value, 10) || 1;

    // Increase quantity
    if (button.classList.contains('quantity-plus')) {
      value++;
    }

    // Decrease quantity
    if (button.classList.contains('quantity-minus') && value > 1) {
      value--;
    }

    input.value = value;

    input.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }

});*/

// Close button fix on cart page
document.addEventListener('keyup', function(event) {

  const removeButton = event.target.closest(
    '.cart__remove .ajax-cart__delete'
  );

  if (!removeButton) return;

  if (event.key === 'Enter') {

    event.preventDefault();
    event.stopImmediatePropagation();

    const removeUrl = removeButton.dataset.removeUrl;

    if (removeUrl) {
      window.location.assign(removeUrl);
    }
  }

});